// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'dataviz-donut';

export const Component = () => (
  <path d='M18.534 13.266v-.048l5.843.862c-.43 2.73-1.58 4.98-3.448 6.848l-4.166-4.166c1.005-.91 1.58-2.107 1.771-3.496ZM14.272.19h-.048l-.958 5.795c1.533.239 2.826.958 3.832 2.155 1.005 1.198 1.532 2.539 1.532 4.12h5.891c0-3.018-.958-5.652-2.921-7.95C19.637 2.058 17.194.67 14.273.19h-.001ZM12.26 18.63c-1.772 0-3.257-.623-4.502-1.868-1.244-1.246-1.868-2.73-1.868-4.502 0-1.772.623-3.257 1.868-4.501 1.198-1.246 2.73-1.868 4.502-1.868V0c-3.4 0-6.274 1.198-8.669 3.592C1.198 5.987 0 8.86 0 12.261c0 3.4 1.198 6.274 3.592 8.669 2.395 2.394 5.268 3.592 8.669 3.592 2.538 0 4.933-.767 7.088-2.25l-3.4-4.79a6.345 6.345 0 0 1-3.687 1.15l-.001-.002Z' />
);

export const viewBox = '0 0 25 25';
